// src/components/ContactForm.jsx
import React, { useState } from 'react';
import { TextField,Button} from '@mui/material';
import { Phone } from '@mui/icons-material';


const ContactForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [formErrors, setFormErrors] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email address is invalid";
    }

    if (!formData.phone.trim()) {
      errors.phone = "Phone number is required";
    } else if (!/^\+?[\d\s-()]{10,}$/.test(formData.phone)) {
      errors.phone = "Please enter a valid phone number";
    }

    if (!formData.message.trim()) {
      errors.message = "Message cannot be empty";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const timestamp = new Date().toISOString();
      const formDataWithTimestamp = {
        ...formData,
        timestamp
      };
      onSubmit(formDataWithTimestamp);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        label="Your Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        fullWidth
        margin="normal"
        error={!!formErrors.name}
        helperText={formErrors.name}
      />
      <TextField
        label="Your Email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        fullWidth
        margin="normal"
        error={!!formErrors.email}
        helperText={formErrors.email}
      />
      <TextField
        label="Phone Number"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        fullWidth
        margin="normal"
        error={!!formErrors.phone}
        helperText={formErrors.phone || "Include country code (e.g., +92 300 1234567)"}
        placeholder="+92 300 1234567"
        InputProps={{
          startAdornment: <Phone sx={{ mr: 1, fontSize: '20px' }} />,
        }}
      />
     <TextField
  label="Your Message"
  name="message"
  value={formData.message}
  onChange={handleChange}
  fullWidth
  multiline
  rows={4}
  margin="normal"
  error={!!formErrors.message}
  helperText={formErrors.message}
/>

<div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
  <Button
    variant="outlined"  // or "outlined" or "text" or "contained"
    color="primary"      // or "secondary", "success", etc.
    size="medium"
    onClick={handleSubmit}
  >
    Send via WhatsApp
  </Button>
</div>

    </form>
  );
};

export default ContactForm;